import { cn } from "@/utils";
import { useCallback } from "react";

interface AvatarProps {
  url?: string | null;
  isOnline?: boolean;
  status?: "online" | "away" | "disabled";
  width?: number;
  height?: number;
  containerClassName?: string;
}

const UserAvatar = ({
  url,
  status,
  width = 40,
  height = 40,
  containerClassName,
}: AvatarProps) => {
  const getClassByStatus = useCallback(() => {
    switch (status) {
      case "online":
        return "bg-green-600";
      case "away":
        return "bg-yellow-400";
      case "disabled":
        return "bg-error_main";
      default:
        return "";
    }
  }, [status]);

  if (url)
    return (
      <div
        className={cn(
          "size-10 rounded-full relative shrink-0",
          containerClassName
        )}
      >
        <img
          src={url}
          alt="User Avatar"
          className="w-full h-full object-cover rounded-full"
          width={width}
          height={height}
        />

        {!!status && (
          <div
            className={cn(
              "absolute bottom-0 right-0 size-4 rounded-full border-2 border-dark_primary",
              getClassByStatus()
            )}
          ></div>
        )}
      </div>
    );

  return (
    <div
      className={cn(
        "size-10 bg-grey-200 rounded-full flex justify-center items-center relative shrink-0",
        containerClassName
      )}
    >
      <img
        src="/svgs/default-avatar.svg"
        width={width}
        height={height}
        alt="User Avatar"
        className="w-full h-full object-cover rounded-full"
      />

      {!!status && (
        <div
          className={cn(
            "absolute bottom-0 right-0 size-4 rounded-full border-2 border-dark_primary",
            getClassByStatus()
          )}
        ></div>
      )}
    </div>
  );
};

export { UserAvatar };
